import { Store } from "@ngxs/store";
import { TealCompEncounter } from "../../../models/encounter";
import { EncounterService } from "../../../services/encounter.service";
import { Fax, FaxWrite, HarloweSupport, IFaxHandler, User } from "@harlowe/core";
import { UtilService } from "@harlowe/core";
import { lastValueFrom } from "rxjs";


export class EncounterFaxHandler implements IFaxHandler {
    constructor
    (
        private _encounter: TealCompEncounter,
        private _encounterService: EncounterService,
        private _utilService: UtilService,
        private _store: Store,

    )
    {}


    getAttachments(): Map<string, HarloweSupport.File[]> 
    {
        return this.attachments;
    }

    async create(): Promise<EncounterFaxHandler>
    {
        this.patientFirstName = this._encounter.referral.claim?.party.firstName as string;
        this.patientFirstName = this.patientFirstName?.toLowerCase();
        this.patientFirstName = this.patientFirstName.charAt(0).toUpperCase() + this.patientFirstName.slice(1);

        this.patientLastName = this._encounter.referral.claim?.party.lastName as string;
        this.patientLastName = this.patientLastName?.toLowerCase(); 
        this.patientLastName = this.patientLastName.charAt(0).toUpperCase() + this.patientLastName.slice(1);

        this.attachments.set("Encounter", this._encounter.attachments);
        this.attachments.set("Referral", this._encounter.referral.attachments);


        return this;
    }

    isReady: boolean = true;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    attachments: Map<string, HarloweSupport.File[]> = new Map();


    newFax(user: User, rmc: boolean): FaxWrite {
        // Start with longest, most descriptive subject, shorten until it's <=55 characters.
        var subject = "Re: " + this.patientFirstName + " " + this.patientLastName
        + " (Enc# " + this._encounter.id + ")";

        var notes = "[[Fax Body]]\n\n"
        + "Thank you for your assistance.\n\nSincerely,\n"
        + user.firstName + " " + user.lastName + ", Nurse Navigator\n"
        + user.emailAddresses[0] + "\n"            

        var pendingFax = new FaxWrite('', user.fullName, subject, notes, '');

        return pendingFax;
    }

    newCgiFax(user: User): FaxWrite {
        return this.newFax(user, false);
    }

    async previewFile(file: HarloweSupport.File)
    {
        // show popup with invoice PDF
        await this._utilService.getFileBlob(file)
        .then
        (
        (blob: Blob) =>
        {
            if (blob.size == 0)
            {
                return;
            }
            
            console.log(blob);
            const url = window.URL.createObjectURL(blob);
            let pwa = window.open(url,"Preview","height=640,width=960,toolbar=no,menubar=no,scrollbars=no,location=no,status=no");
        }
        )
        .catch
        (
        (e: { error: any; }) =>
        {
            console.log(e);
        }
        )    
    }

    sendFax(fax: FaxWrite): Promise<Fax>
    {
        //send the fax
        return this._encounterService.sendEncounterFax(this._encounter?.id as number, fax);

    }
}
